import client from '../../Components/Client';
import service from './service';

export const getDocument = async (documentId) => {
  const response = await service.get(`/declarations/${documentId}`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export default {
  getDocument,
};
